<footer class="relative bg-blueGray-200 pt-8 pb-6" style="direction: rtl;">
  <!-- <div
    class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
    style="transform: translateZ(0)"
  >
    <svg
      class="absolute bottom-0 overflow-hidden"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      version="1.1"
      viewBox="0 0 2560 100"
      x="0"
      y="0"
    >
      <polygon
        class="text-blueGray-200 fill-current"
        points="2560 0 2560 100 0 100"
      ></polygon>
    </svg>
  </div> -->

  <div class="container mx-auto px-4">
    <div class="flex flex-wrap text-right ">

      <div class="w-full lg:w-4/12 px-4">
        <h4 class="text-xl flex font-semibold "> 
          <img class="w-8 ml-2" src="../../../../assets/img/Ostadvisit-Logo-color.svg" alt="">
          استاد ویزیت </h4>
        <p class="text-sm my-2 text-blueGray-600">
          استادویزیت یک پلتفرم نوین در حوزه خدمات پزشکی آنلاین است که ارتباطی سریع،
           ایمن و آسان بین بیماران و پزشکان برقرار می‌کند. ما معتقدیم که دسترسی به خدمات درمانی نباید به زمان و مکان محدود باشد. به همین دلیل، با بهره‌گیری از فناوری‌های روز،
            امکان ویزیت تصویری، تلفنی و متنی را فراهم کرده‌ایم تا هر فرد بتواند در هر لحظه و از هر نقطه، با پزشک متخصص موردنظر خود مشورت کند.
        </p>
      </div>

      <div class="w-full lg:w-2/12 px-4">
        <h4 class="text-xl font-semibold"> با ما در ارتباط باشید </h4>
        <!-- <h5 class="text-base my-2 text-blueGray-600">
          شما می توانید از طریق راه های زیر با ما در تماس باشید.
        </h5> -->
        <div class="mt-3 lg:mb-0 mb-6">
          <div>
            <a class="flex items-center my-2" href="mailto:info@ostadvisit.com">
            <button
              class=" text-primary font-normal w-5 items-center justify-center align-center rounded-full outline-none focus:outline-none ml-2"
              type="button">
              <img src="../../../../assets/img/icon/email.svg" alt="">
            </button>
            <span> info&#64;ostadvisit.com </span>
            </a>
          </div>
          <div>
            <a class="flex items-center my-2" href="tel:07132281818">
            <button
              class=" text-primary font-normal w-5 items-center justify-center align-center rounded-full outline-none focus:outline-none ml-2"
              type="button" >
              <img src="../../../../assets/img/icon/contact.svg" alt="">
            </button>
            <span> 07132281818 </span>
            </a>
            <a class="mx-6 my-2" href="tel:07132281919">
              <span> 07132281919 </span>
              </a>
          </div>          
        </div>
      </div>
      <div class="w-full lg:w-2/12 px-4">
        <div class="flex flex-wrap items-top mb-6">
          <div class="w-full px-4 ml-auto">
            <span class="text-xl font-semibold">
              صفحات
            </span>
            <ul class="list-unstyled my-2">
              <li>
                <a
                  class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                  routerLink="/about-us">
                  درباره ما
                </a>
              </li>
              <li>
                <a
                  class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                  routerLink="/blog">
                  مجله سلامت
                </a>
              </li>
              <li>
                <a
                  class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                  routerLink="/terms">
                  قوانین و مقررات
                </a>
              </li>
              <li>
                <a
                  class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                  routerLink="/privacy">
                  حریم خصوصی
                </a>
              </li>
            </ul>
          </div>
          <!-- <div class="w-full lg:w-4/12 px-4">
            <span
              class="block uppercase text-blueGray-500 text-sm font-semibold mb-2"
            >
              Other Resources
            </span>
            <ul class="list-unstyled">
              <li>
                <a
                  class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                  href="https://github.com/creativetimofficial/notus-angular/blob/main/LICENSE.md?ref=creativetim"
                >
                  MIT License
                </a>
              </li>
              <li>
                <a
                  class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                  href="https://creative-tim.com/terms?ref=na-footer"
                >
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a
                  class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                  href="https://creative-tim.com/privacy?ref=na-footer"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                  href="https://creative-tim.com/contact-us?ref=na-footer"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div> -->
        </div>
      </div>
      <div class="w-full lg:w-3/12 px-4">
        <div class="flex justify-center items-center">
          <div class="w-1/3 box-logo" style="padding-bottom:20px;padding-top:15px"><a referrerpolicy="origin" target="_blank"
            href="//trustseal.enamad.ir/?id=274229&amp;Code=rr3dpGXE3o3THl9Y0MUB"> <img referrerpolicy="origin"
              loading="lazy" src="//Trustseal.eNamad.ir/logo.aspx?id=274229&amp;Code=rr3dpGXE3o3THl9Y0MUB"
              alt="نماد اعتماد الکترونیکی" style="cursor:pointer" id="rr3dpGXE3o3THl9Y0MUB"> </a></div>
          <div class="w-1/3 m-3 box-logo">
            <div class="col-12"><img id="rgvjjxlzrgvjjzpeoeukapfu" style="cursor:pointer;width:100px;height:100px"
              onclick="window.open(&quot;https://logo.samandehi.ir/Verify.aspx?id=313785&amp;p=qftinbpdqftiyndtaqgwujyn&quot;,&quot;Popup&quot;,&quot;toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30&quot;)"
              alt="logo-samandehi" src="/images/samandehi.png"></div>
          </div>
          <div class="w-1/3 p-2 box-logo">
            <div style="cursor:pointer" onclick="window.open('https://www.zarinpal.com/trustPage/'+window.location.hostname,null,'width=450, height=600, scrollbars=no, resizable=no')" title="پرداخت امن "><img src="/images/zarin-logo.svg" alt="استاد ویزیت" width="77" height="100"></div>
          </div>
        </div>
      </div>
    </div>
    <hr class="my-6 border-blueGray-300" />
    <div class="flex flex-wrap items-center md:justify-between justify-center">
      <div class="w-full md:w-4/12 px-4 mx-auto text-center">
        <div class="text-sm text-blueGray-500 font-semibold py-1">
          کلیه حقوق برای  
          <a
            class="text-blueGray-500 hover:text-blueGray-800"
          >
          ویستا طب آوای سلامت
          </a>
          محفوظ است © {{ date }}
        </div>
      </div>
      <div class="w-full md:w-4/12 px-4 mx-auto text-center">
        <div class="text-sm text-blueGray-500 font-semibold py-1">
          <span class="text-blueGray-500 "> فرادید </span>
          <a
            href="https://medis.land/"
            class="text-blueGray-500 hover:text-blueGray-800"
          >
           مدیس
          </a>
        </div>
      </div>
    </div>
  </div>
</footer>
